import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { SVGIcon as Icon } from 'common/components';

import './temporary-closures.less';

const TemporaryClosures = ({ closedInfo, title, mode, onDetails }) => {
  const classNames = useClassName('TemporaryClosures');
  const [visible, setVisible] = useState(false);
  const isCta = mode === 'cta';

  if (!isCta && !closedInfo) return null;

  return (
    <div className={classNames(['container', isCta ? 'cta' : ''])}>
      <p
        onClick={() => (isCta ? onDetails?.() : setVisible(!visible))}
        className={classNames('title')}>
        <Icon name="construction" className={classNames('title__icon')} />
        <span>{title}</span>
        {isCta ? (
          <span
            className={classNames('cta-link')}
            onClick={(e) => {
              e.stopPropagation();
              onDetails?.();
            }}>
            Details
          </span>
        ) : (
          <Icon
            name={visible ? 'angle-up' : 'angle-down'}
            className={classNames('title__arrow')}
          />
        )}
      </p>
      {!isCta && visible && (
        <div className={classNames('text')}>
          {closedInfo.message.split('\n').map((line, index) => (
            <p key={index}>{line || ' '}</p>
          ))}
        </div>
      )}
    </div>
  );
};

TemporaryClosures.propTypes = {
  closedInfo: PropTypes.shape({
    message: PropTypes.string,
  }),
  title: PropTypes.string,
  // 'toggle' (default): expandable accordion. 'cta': static row with a
  // "Details" link that calls onDetails (used below the checkout date cards).
  mode: PropTypes.oneOf(['toggle', 'cta']),
  onDetails: PropTypes.func,
};

TemporaryClosures.defaultProps = {
  closedInfo: null,
  title: 'Temporary closures on this date',
  mode: 'toggle',
  onDetails: null,
};

export default TemporaryClosures;
